import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class MSGraphPlanner extends CloudObject {

    /**
     * Creates an instance of MSGraphPlanner.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create (transaction) {
        return transaction.create(MSGraphPlanner);
    }

    /**
     * @return {Date}
     */
    getCreatedDateTime () {
        return this.get(MSGraphPlanner.createdDateTimeProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeCreatedDateTime ($) {
        return this.observe($, MSGraphPlanner.createdDateTimeProp);
    }

    /**
     * @return {string}
     */
    getTitle () {
        return this.get(MSGraphPlanner.titleProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeTitle ($) {
        return this.observe($, MSGraphPlanner.titleProp);
    }

    /**
     * @return {string}
     */
    getId () {
        return this.get(MSGraphPlanner.idProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeId ($) {
        return this.observe($, MSGraphPlanner.idProp);
    }

    /**
     * @return {string}
     */
    getContainerId () {
        return this.get(MSGraphPlanner.containerIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeContainerId ($) {
        return this.observe($, MSGraphPlanner.containerIdProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setCreatedDateTime (transaction, instance, value) {
        transaction.update(instance, MSGraphPlanner.createdDateTimeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setTitle (transaction, instance, value) {
        transaction.update(instance, MSGraphPlanner.titleProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setId (transaction, instance, value) {
        transaction.update(instance, MSGraphPlanner.idProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setContainerId (transaction, instance, value) {
        transaction.update(instance, MSGraphPlanner.containerIdProp, value);
    }

}

// Hardcoded tags
register('018d3a833d16a133d150', MSGraphPlanner);
MSGraphPlanner.createdDateTimeProp = defineProperty('018d3a9275d1e62585e7');
MSGraphPlanner.titleProp = defineProperty('018d3a92b62592218240');
MSGraphPlanner.idProp = defineProperty('018d3a933567a359983f');
MSGraphPlanner.containerIdProp = defineProperty('018d402798026df08e1b');
